<template>
  <v-app>
    <v-form ref="form" v-model="valid" @submit.prevent="submit">
      <v-container fluid>
        <div class="mb-2 col-12">
            <p class="tc-subtitle">Enhance your next lesson plan with a Teacher Collection of library materials to use in your classroom.</p>
            <p>Here's how it works:</p>
            <ul>
              <li>
                <p>Multiple copy requests are not guaranteed and will be filled based on availability of titles.</p>
              </li>
              <li>
                <p>We need a minimum of 14 days' notice to fulfill your request.</p>
              </li>
              <li>
                <p>A Teacher Collection can include a maximum of 30 print/audio items and five DVDs which can be on a specific subject, by a particular author or a general collection of fiction and nonfiction books.</p>
              </li>
              <li>
                <p>Requests for seasonal books, curriculum-related books in high demand, and books by visiting authors may be limited due to availability.</p>
              </li>
              <li>
                <p>A teacher can request a maximum of two Teacher Collections per month while not exceeding the library's borrowing limits.</p>
              </li>
              <li>
                <p>You must be a certified K-12 school teacher, licensed childcare instructor or verified homeschool educator with a valid <a v-bind:href="cardUrl" target="_blank">Educator Card</a> from Columbus Metropolitan Library. Want to apply? Stop by any location.</p>
              </li>
              <li>
                <p>Call 614-645-2275 for more information.</p>
              </li>
            </ul>
        </div>

        <h2 class="mb-6 pl-2">Login</h2>
        <p class="mb-4 pl-2 help-block"><strong class="asterix">* </strong>indicates required field.</p>

        <div class="pl-4">
          <v-row>
            <v-col class="d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4">
              <template>
                <div>
                  <h4><strong>Library Card</strong><strong class="asterix"> *</strong></h4>
                  </div>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4">
              <v-text-field v-model="form.teacherCard" outlined label="Library Card" :value="form.teacherCard" :rules="[rules.required, rules.card]" type="text" v-on:keypress="isNumber($event)"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4">
              <template>
                <div>
                  <h4><strong>PIN Number</strong><strong class="asterix"> *</strong></h4>
                  </div>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4">
              <v-text-field v-model="form.teacherPin" outlined label="PIN Number" :value="form.teacherPin" :rules="[rules.required, rules.pin]" :type="show ? 'text' : 'password'" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" v-on:keypress="isNumber($event)" @click:append="show = !show"></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-btn type="submit" class="tc-button submit-btn">Submit</v-btn>
        <v-btn @click="cancel()" class="ml-4 tc-button">
          <v-icon class="pr-1">mdi-close-thick</v-icon>Cancel
        </v-btn>

      </v-container>
    </v-form>
  </v-app>
</template>

<script>

const axios = require("axios");

export default {
  data() {
    return {
      valid: true,
      show: false,
      cardUrl: "https://www.columbuslibrary.org/wp-content/uploads/2025/01/Educator-Card-Bookmark.pdf",
      form: {
        teacherCard: "",
        teacherPin: "",
      },
      rules: {
        required: value => !!value || "Required",
        pin: value => (value && value.length === 4) || "Please enter your 4 digit pin.",
        card: value => (value && value.length === 10) || "Please enter your 10 card number"
      },
    }
  },
  props: ['loginUrl', 'cmlUrl'],
  methods: {
    submit() {
      this.$refs.form.validate() && axios.post(this.loginUrl, this.form)
      .then(response => {
        response.data.patron && (this.$emit('logged-in', ['Form', response.data.patron]))
      })
      .catch(error => {
        alert(error.response.data.error);
      });
    },
    cancel() {
      window.location.replace(this.cmlUrl);
    },
    isNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) return true;
            else e.preventDefault();
        }
  }
}
</script>
